export default __webpack_public_path__ + "static/banner1800-27cf66074015868471ee3a3962abcdaa.png";